"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const lodash_1 = __importDefault(require("lodash"));
const calculateLocalBatchItem_1 = __importDefault(require("./calculateLocalBatchItem"));
const calculateLocalOrderTax_1 = __importDefault(require("./calculateLocalOrderTax"));
const calculateOrderSurcharge_1 = __importDefault(require("./calculateOrderSurcharge"));
const fixPrecision_1 = require("./fixPrecision");
const getDisplayStatusKey_1 = __importDefault(require("./getDisplayStatusKey"));
const precisionMath_1 = require("./precisionMath");
const round_1 = __importStar(require("./round"));
const sortOrderModifiers_1 = require("./sortOrderModifiers");
const calculateLocalOrerUtil_1 = require("./calculateLocalOrerUtil");
/**
 * Get the effective tax from batch items that are actually applied and have percent > 0
 * @param order The order to extract tax from
 * @returns The first tax with percent > 0 that is actually applied in batch items, or undefined
 */
function getEffectiveTaxFromBatchItems(order) {
    var _a;
    const originalTaxes = (_a = order.taxes) !== null && _a !== void 0 ? _a : [];
    // Create a map of tax ID to tax object for quick lookup
    const taxMap = new Map();
    originalTaxes.forEach(tax => {
        if (tax.percent > 0) {
            taxMap.set(tax.id, tax);
        }
    });
    // Find the first tax that is actually used in batch items
    let foundTax;
    (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, item => {
        if (foundTax)
            return; // Already found, skip remaining items
        if (item.taxSettingIds) {
            for (const taxId of item.taxSettingIds) {
                const tax = taxMap.get(taxId);
                if (tax) {
                    foundTax = tax;
                    return;
                }
            }
        }
    });
    return foundTax;
}
function calculateLocalOrder(appOrder) {
    return (0, immer_1.produce)(appOrder, order => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        // FIXME: 目前只支援單一稅率的計算, 多個稅率會有問題, 但實例上也不會有多個>0%的稅率, 所以先這樣寫, 以後再fix
        // 會先把 order.taxes 設成只有一個稅率的陣列來計算, 最後再還原
        // Save all original tax settings
        const originalTaxes = (_a = order.taxes) !== null && _a !== void 0 ? _a : [];
        // Get the tax that is actually applied in batch items and has percent > 0
        const effectiveTax = getEffectiveTaxFromBatchItems(order);
        order.taxes = effectiveTax ? [effectiveTax] : [];
        // ======================== 計算 item level ========================
        // 餐點原價
        let productsOriginalTotal = 0;
        // 餐點小計 (餐點原價加總不含 DISCOUNT 折扣，但會含 COMBORULE, MERCHANT)
        let productsSubtotal = 0;
        // 餐點總價 (經過折扣) = itemSubtotal - itemDiscount
        let productsTotal = 0;
        // 項目折扣 (只包含 DISCOUNT 折扣)
        let productDiscountModifiersDiscount = 0;
        // 項目折扣 (只包含 COMBORULE 撞餐和 MERCHANT 改價)
        let productMerchantModifiersDiscount = 0;
        order.batches = lodash_1.default.map(order.batches, batch => {
            const calculatedItems = batch.items.map(item => (0, calculateLocalBatchItem_1.default)(item, order));
            if (['submitted', 'confirmed'].includes(batch.status)) {
                // 只計算 submitted, confirmed 的 batch
                productsOriginalTotal += lodash_1.default.sumBy(calculatedItems, 'originalTotal');
                productDiscountModifiersDiscount += lodash_1.default.sumBy(calculatedItems, 'totalDiscountModifiersDiscount');
                productMerchantModifiersDiscount += lodash_1.default.sumBy(calculatedItems, 'totalMerchantModifiersDiscount');
                productsSubtotal += lodash_1.default.sumBy(calculatedItems, 'totalWithoutDiscountModifiers');
                productsTotal += lodash_1.default.sumBy(calculatedItems, 'total');
            }
            return Object.assign(Object.assign({}, batch), { items: calculatedItems });
        });
        // ======================== 計算 order level ========================
        // * 計算運費
        let shippingFeeBaseTotal = 0; // 可用來計算 shipping modifier 的運費 (不含小額服務費)
        let smallOrderFee = 0; // 小額服務費
        if (order.shipping != null && order.deliveryType === 'storeDelivery') {
            shippingFeeBaseTotal = (0, precisionMath_1.add)((0, precisionMath_1.add)(((_b = order.shipping.baseShippingFee) !== null && _b !== void 0 ? _b : 0), ((_c = order.shipping.tunnelFee) !== null && _c !== void 0 ? _c : 0)), ((_d = order.shipping.longDistanceFee) !== null && _d !== void 0 ? _d : 0));
            smallOrderFee = (_e = order.shipping.smallOrderFee) !== null && _e !== void 0 ? _e : 0;
        }
        // * 計算 modifiers
        // 加總所有可以折扣的 total，用來分攤 amount 折扣，一律使用折扣後的 total，避免折超過餐點金額
        let discountableTotalAcc = 0;
        let discountableTotalWithoutItemDiscountAcc = 0;
        const prepareItem = (item) => {
            var _a, _b, _c, _d;
            // reset 前一次計算留下的 order level 折扣，避免重算時被重複扣除
            item.orderDiscountAmount = 0;
            // 以下兩個欄位用來分攤 Order level 的折扣
            // 不論是否設定 isOrderProductModifierBasedOnDiscountedItemTotal ，兩者都要在折扣後計算，避免折扣超過餐點金額
            // reset 用來分攤 order level 折扣的 total (含折扣版)
            item.totalWithoutSetItemsAfterOrderDiscount = (_a = item.totalWithoutSetItems) !== null && _a !== void 0 ? _a : 0;
            // reset 用來分攤 order level 折扣的 total (不含折扣版)
            item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount = (_b = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _b !== void 0 ? _b : 0;
            if (!item.excludeOrderDiscount) {
                discountableTotalAcc = (0, precisionMath_1.add)(discountableTotalAcc, (_c = item.totalWithoutSetItems) !== null && _c !== void 0 ? _c : 0);
                discountableTotalWithoutItemDiscountAcc = (0, precisionMath_1.add)(discountableTotalWithoutItemDiscountAcc, (_d = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _d !== void 0 ? _d : 0);
            }
        };
        (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, prepareItem);
        // 算出不可折扣的部分，當 order modifier 有設定 overrideItem 時會用到
        const nonDiscountableTotalAcc = (0, precisionMath_1.subtract)(productsTotal, discountableTotalAcc);
        // 可以用來算 SHIPPING 折扣的 shippingFee
        let shippingFeeAcc = shippingFeeBaseTotal;
        // 可以用來算 ALL 折扣的 total，計算服務費之後還要再加上服務費
        // FIXME: 這裡的 allAcc 需要考慮到服務費的計算
        // 可被All modifier 折扣的總計
        let allAcc = (0, precisionMath_1.add)((0, precisionMath_1.add)(productsTotal, shippingFeeBaseTotal), smallOrderFee);
        // item 折不完的 All modifier 折扣
        let allModifierDiscountAmountLeft = 0;
        const surchargeModifier = (_f = order.modifiers) === null || _f === void 0 ? void 0 : _f.find(modifier => modifier.type === 'SURCHARGE');
        order.modifiers = (0, sortOrderModifiers_1.sortOrderModifiers)((_g = order.modifiers) !== null && _g !== void 0 ? _g : [])
            .filter(modifier => modifier.type !== 'SURCHARGE')
            .map(modifier => {
            if (modifier.deletedAt != null) {
                // * 被刪除的 modifier 不做計算
                return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
            if (modifier.type === 'RICECOIN' && order.deliveryType === 'table') {
                // * 堂食不可用 RiceCoin
                return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
            if ((modifier.percent > 0 || modifier.amount > 0)) {
                // * 不可加價
                return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
            switch (modifier.applyTo) {
                case 'SHIPPING': {
                    // * 計算運費折扣 (運費折扣不可折到 smallOrderFee)
                    if (order.deliveryType !== 'storeDelivery') {
                        // * 非外送訂單不折扣運費
                        return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
                    }
                    // 折扣後金額 (不可低於 0)
                    const totalWithModifier = Math.max(0, (0, precisionMath_1.add)((0, precisionMath_1.multiply)(shippingFeeAcc, (0, precisionMath_1.divide)((0, precisionMath_1.add)(100, modifier.percent), 100)), modifier.amount));
                    // 折扣金額 (不可大於 shippingFeeAcc)
                    let discountValue = Math.min(shippingFeeAcc, (0, precisionMath_1.subtract)(shippingFeeAcc, totalWithModifier));
                    // 折扣金額不可 < 0
                    discountValue = Math.max(0, discountValue);
                    // 如需中途進位
                    discountValue = order.enableIntermediateRounding ? (0, round_1.default)(discountValue, order.rounding.type, order.rounding.digits) : discountValue;
                    // 從運費折扣總計扣除
                    shippingFeeAcc = (0, precisionMath_1.subtract)(shippingFeeAcc, discountValue);
                    // 從全單用折扣的總計扣除
                    allAcc = (0, precisionMath_1.subtract)(allAcc, discountValue);
                    // 寫入 modifier 中
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: -discountValue });
                }
                case 'PRODUCT': {
                    // Loop 1: 計算總折扣金額
                    let totalDiscountValueAcc = 0; // 這個 modifier 的總折扣金額
                    let totalForCalculationSum = 0; // 所有參與折扣的 item 總和
                    const denominatorForAmount = modifier.overrideItem
                        ? (0, precisionMath_1.add)(discountableTotalAcc, nonDiscountableTotalAcc)
                        : order.isOrderProductModifierBasedOnDiscountedItemTotal === true ? discountableTotalAcc : discountableTotalWithoutItemDiscountAcc;
                    const calculateDiscountAmount = (item) => {
                        var _a, _b;
                        if (item.excludeOrderDiscount && !modifier.overrideItem) {
                            return;
                        }
                        const itemTotalForCalculation = order.isOrderProductModifierBasedOnDiscountedItemTotal === true
                            ? (_a = item.totalWithoutSetItemsAfterOrderDiscount) !== null && _a !== void 0 ? _a : 0
                            : (_b = item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount) !== null && _b !== void 0 ? _b : 0;
                        // 累加所有參與折扣的 item 總和（用於 Loop 2 攤分）
                        totalForCalculationSum = (0, precisionMath_1.add)(totalForCalculationSum, itemTotalForCalculation);
                        // 確定折扣金額
                        let discountAmount = 0;
                        // 處理百分比折扣
                        if (modifier.percent !== 0) {
                            const estDiscountAmount = Math.max(0, (0, precisionMath_1.multiply)(itemTotalForCalculation, (0, precisionMath_1.divide)(-modifier.percent, 100)));
                            discountAmount = Math.min(estDiscountAmount, itemTotalForCalculation);
                            totalDiscountValueAcc = (0, precisionMath_1.add)(totalDiscountValueAcc, discountAmount);
                        }
                        // 處理固定金額折扣
                        if (modifier.amount !== 0) {
                            if (denominatorForAmount > 0) {
                                const distributedAmount = Math.min(-modifier.amount, (0, precisionMath_1.divide)((0, precisionMath_1.multiply)(-modifier.amount, itemTotalForCalculation), denominatorForAmount));
                                discountAmount = Math.min(distributedAmount, itemTotalForCalculation);
                                totalDiscountValueAcc = (0, precisionMath_1.add)(totalDiscountValueAcc, discountAmount);
                            }
                        }
                    };
                    (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, calculateDiscountAmount);
                    // 如需中途進位
                    totalDiscountValueAcc = order.enableIntermediateRounding ? Math.min(totalForCalculationSum, (0, round_1.default)(totalDiscountValueAcc, order.rounding.type, order.rounding.digits)) : totalDiscountValueAcc;
                    // 在可折扣總額中扣除已折的金額
                    if (order.isOrderProductModifierBasedOnDiscountedItemTotal === true) {
                        discountableTotalAcc = (0, precisionMath_1.subtract)(discountableTotalAcc, totalDiscountValueAcc);
                    }
                    else {
                        discountableTotalWithoutItemDiscountAcc = (0, precisionMath_1.subtract)(discountableTotalWithoutItemDiscountAcc, totalDiscountValueAcc);
                    }
                    // Loop 2: 將折扣攤分到各個 item (只在折扣 > 0 時執行)
                    if (totalDiscountValueAcc > 0 && totalForCalculationSum > 0) {
                        const distributeDiscount = (item) => {
                            var _a, _b, _c;
                            if (item.excludeOrderDiscount && !modifier.overrideItem) {
                                return;
                            }
                            const itemTotalForCalculation = order.isOrderProductModifierBasedOnDiscountedItemTotal === true
                                ? (_a = item.totalWithoutSetItemsAfterOrderDiscount) !== null && _a !== void 0 ? _a : 0
                                : (_b = item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount) !== null && _b !== void 0 ? _b : 0;
                            // 按比例攤分總折扣金額
                            const itemProportion = (0, precisionMath_1.divide)(itemTotalForCalculation, totalForCalculationSum);
                            const itemDiscountValue = Math.min((0, precisionMath_1.multiply)(totalDiscountValueAcc, itemProportion), itemTotalForCalculation);
                            // 更新 item 的 total，確保不會折超過
                            if (order.isOrderProductModifierBasedOnDiscountedItemTotal === true) {
                                item.totalWithoutSetItemsAfterOrderDiscount = Math.max(0, (0, precisionMath_1.subtract)(itemTotalForCalculation, itemDiscountValue));
                            }
                            else {
                                item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount = Math.max(0, (0, precisionMath_1.subtract)(itemTotalForCalculation, itemDiscountValue));
                            }
                            item.orderDiscountAmount = (0, precisionMath_1.add)((_c = item.orderDiscountAmount) !== null && _c !== void 0 ? _c : 0, itemDiscountValue);
                        };
                        (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, distributeDiscount);
                    }
                    allAcc = (0, precisionMath_1.subtract)(allAcc, totalDiscountValueAcc);
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: -totalDiscountValueAcc });
                }
                case 'ALL': {
                    // ALL 無視 excludeOrderDiscount 且可以折 shipping.smallOrderFee，全部訂單金額都適用
                    // 計算總折扣金額
                    const totalWithModifier = Math.max(0, (0, precisionMath_1.add)((0, precisionMath_1.multiply)(allAcc, (0, precisionMath_1.divide)((0, precisionMath_1.add)(100, modifier.percent), 100)), modifier.amount));
                    let discountValue = Math.min(allAcc, (0, precisionMath_1.subtract)(allAcc, totalWithModifier));
                    discountValue = Math.max(0, discountValue);
                    // 如需中途進位
                    discountValue = order.enableIntermediateRounding ? Math.min(allAcc, (0, round_1.default)(discountValue, order.rounding.type, order.rounding.digits)) : discountValue;
                    // 從全單用總計扣除
                    allAcc = (0, precisionMath_1.subtract)(allAcc, discountValue);
                    // 將折扣攤分到 item (用於後續稅金計算)
                    if (discountValue > 0 && allAcc > 0) {
                        const originalAllAcc = (0, precisionMath_1.subtract)((0, precisionMath_1.subtract)((0, precisionMath_1.add)(allAcc, discountValue), shippingFeeBaseTotal), smallOrderFee);
                        // 計算多少分配到 item 上
                        let amountDistributedToItems = 0;
                        const distributeAllDiscount = (item) => {
                            var _a, _b, _c;
                            const itemTotalForCalculation = order.isOrderProductModifierBasedOnDiscountedItemTotal === true
                                ? (_a = item.totalWithoutSetItemsAfterOrderDiscount) !== null && _a !== void 0 ? _a : 0
                                : (_b = item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount) !== null && _b !== void 0 ? _b : 0;
                            if (itemTotalForCalculation > 0 && originalAllAcc > 0) {
                                const itemProportion = (0, precisionMath_1.divide)(itemTotalForCalculation, originalAllAcc);
                                const itemDiscountValue = (0, precisionMath_1.multiply)(discountValue, itemProportion);
                                if (order.isOrderProductModifierBasedOnDiscountedItemTotal === true) {
                                    item.totalWithoutSetItemsAfterOrderDiscount = Math.max(0, (0, precisionMath_1.subtract)(itemTotalForCalculation, itemDiscountValue));
                                }
                                else {
                                    item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount = Math.max(0, (0, precisionMath_1.subtract)(itemTotalForCalculation, itemDiscountValue));
                                }
                                item.orderDiscountAmount = (0, precisionMath_1.add)((_c = item.orderDiscountAmount) !== null && _c !== void 0 ? _c : 0, itemDiscountValue);
                                amountDistributedToItems = (0, precisionMath_1.add)(amountDistributedToItems, itemDiscountValue);
                            }
                        };
                        (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, distributeAllDiscount);
                        // if (amountDistributedToItems < discountValue) {
                        allModifierDiscountAmountLeft = (0, precisionMath_1.add)(allModifierDiscountAmountLeft, discountValue - amountDistributedToItems);
                        // }
                    }
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: -discountValue });
                }
                default:
                    // 其他奇怪的情況，先讓他為 0
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
        });
        // 計算 totalAfterDiscount：含所有折扣（item + order）的最終金額
        // 詳細說明見 IAppBatchItem.totalAfterDiscount 的註解
        (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, item => {
            var _a, _b;
            const finalPrice = (0, precisionMath_1.subtract)((_a = item.totalWithoutSetItems) !== null && _a !== void 0 ? _a : 0, (_b = item.orderDiscountAmount) !== null && _b !== void 0 ? _b : 0);
            item.totalAfterDiscount = finalPrice; // roundToFiveDecimal(finalPrice)
        });
        // validate order modifier discount 不超過食物item 折後總額
        const discountModifier = (_h = order.modifiers) === null || _h === void 0 ? void 0 : _h.find(modifier => modifier.type === 'DISCOUNT' && modifier.calculatedAmount != null);
        // productsTotal
        if (discountModifier != null && (0, precisionMath_1.multiply)(discountModifier.calculatedAmount, -1) > productsTotal) {
            const adjustedCalculatedAmount = (0, precisionMath_1.multiply)(productsTotal, -1);
            discountModifier.calculatedAmount = adjustedCalculatedAmount;
        }
        // 計算項目的稅，只有項目的稅
        const { nonTaxableTotal: nonTaxableItemTotal } = (0, calculateLocalOrderTax_1.default)(order);
        // 全部折扣總計 = 全部折扣的 calculatedAmount 不含服務費，服務費後面才算，這邊order modifiers沒有服務費
        const modifiersDiscountAmountTotal = lodash_1.default.sumBy(order.modifiers, 'calculatedAmount');
        // 計算服務費
        const { modifier: surchargeModifierResult } = (_j = (0, calculateOrderSurcharge_1.default)(order, surchargeModifier)) !== null && _j !== void 0 ? _j : {};
        // 如無tax, 把服務費加入到 nonTaxableTotal
        const isSurchargeTaxable = lodash_1.default.isObject(order.surchargeTax) && order.surchargeTax.percent > 0 && ((_k = surchargeModifierResult === null || surchargeModifierResult === void 0 ? void 0 : surchargeModifierResult.calculatedAmount) !== null && _k !== void 0 ? _k : 0) > 0;
        const nonTaxableTotal = nonTaxableItemTotal + (isSurchargeTaxable ? 0 : ((_l = surchargeModifierResult === null || surchargeModifierResult === void 0 ? void 0 : surchargeModifierResult.calculatedAmount) !== null && _l !== void 0 ? _l : 0));
        if (surchargeModifierResult != null) {
            order.modifiers.push(surchargeModifierResult);
        }
        // 服務費(顯示)
        const surcharge = (_m = surchargeModifierResult === null || surchargeModifierResult === void 0 ? void 0 : surchargeModifierResult.calculatedAmount) !== null && _m !== void 0 ? _m : 0;
        // 運費 = 折扣後運費 + 小額服務費
        const shippingFee = (0, precisionMath_1.add)(shippingFeeAcc, smallOrderFee);
        // 運費原價 = 運費 + 小額服務費
        const originalShippingFee = (0, precisionMath_1.add)(shippingFeeBaseTotal, smallOrderFee);
        // 運費折扣總計 = 運費原價 - 運費折扣後總計
        const discountShippingFee = (0, precisionMath_1.subtract)(originalShippingFee, shippingFee);
        // 計算taxableTotal (全部用來收稅的金額總計)
        // 補算ALL modifier的calculatedAmount進去taxableTotal
        // eg: 原本100$, ricecoin-50$, 運冀10$ = 100+10-50=60 taxableTotal
        // TODO: 這邊還要再修, 畢竟all, shipping fee是否taxable還待確認, 還要處理all折超過item total的情況, 要把shipping, surcharge都可以讓all去折
        // const applyToAllModifierCalculatedTotal = _.sumBy(order.modifiers?.filter(modifier => modifier.applyTo === 'ALL'), 'calculatedAmount') + allModifierDiscountAmountLeft
        const taxableTotal = (0, precisionMath_1.subtract)((0, precisionMath_1.add)((0, precisionMath_1.add)(lodash_1.default.sumBy(order.taxes, 'taxableTotal'), (_p = (_o = order.surchargeTax) === null || _o === void 0 ? void 0 : _o.taxableTotal) !== null && _p !== void 0 ? _p : 0), shippingFee), allModifierDiscountAmountLeft);
        // 總稅額
        const tax = (_r = (_q = order === null || order === void 0 ? void 0 : order.taxes) === null || _q === void 0 ? void 0 : _q.find(t => t.percent > 0)) !== null && _r !== void 0 ? _r : { percent: 0, taxableTotal: 0 };
        const rawTaxTotal = (0, precisionMath_1.divide)((0, precisionMath_1.multiply)(taxableTotal, tax.percent), 100);
        // 稅前總計
        const rawTotalBeforeTax = (0, precisionMath_1.add)(taxableTotal, nonTaxableTotal);
        // const totalBeforeTax = order.enableIntermediateRounding ? roundByCurrency(order, rawTotalBeforeTax) : rawTotalBeforeTax
        // 總計 = 稅前總計 + 稅
        const total = (0, precisionMath_1.add)(rawTotalBeforeTax, rawTaxTotal);
        const taxTotal = (0, round_1.roundByCurrency)(order, rawTaxTotal);
        // 服務費
        order.surchargeTotal = (0, fixPrecision_1.roundToFiveDecimal)(surcharge);
        // 稅
        order.taxTotal = (0, fixPrecision_1.roundToFiveDecimal)(taxTotal);
        order.taxableTotal = (0, fixPrecision_1.roundToFiveDecimal)(taxableTotal);
        order.nonTaxableTotal = (0, fixPrecision_1.roundToFiveDecimal)(nonTaxableTotal);
        // 運費
        order.shippingFee = (0, fixPrecision_1.roundToFiveDecimal)(shippingFee);
        order.originalShippingFee = (0, fixPrecision_1.roundToFiveDecimal)(originalShippingFee);
        order.discountShippingFee = (0, fixPrecision_1.roundToFiveDecimal)(discountShippingFee);
        // 餐點原價總計
        order.originalTotal = (0, fixPrecision_1.roundToFiveDecimal)((0, precisionMath_1.subtract)(productsOriginalTotal, productMerchantModifiersDiscount));
        // 餐點小計 (餐點原價加總不含折扣)
        const subtotal = order.enableIntermediateRounding
            ? (0, round_1.default)(productsSubtotal, order.rounding.type, order.rounding.digits)
            : productsSubtotal;
        order.subtotal = (0, fixPrecision_1.roundToFiveDecimal)(subtotal);
        // 折扣總計
        const arr = [(0, precisionMath_1.subtract)(modifiersDiscountAmountTotal, productDiscountModifiersDiscount), -subtotal];
        // FIXME: 無法解釋的邏輯，但舊production行為是這樣
        if (order.deliveryType === 'storeDelivery') {
            arr.pop(); // 外送訂單不Max subtotal
        }
        const rawCalculatedDiscountTotal = Math.max(...arr);
        const calculatedDiscountTotal = order.enableIntermediateRounding ? (0, round_1.default)(rawCalculatedDiscountTotal, order.rounding.type, order.rounding.digits) : rawCalculatedDiscountTotal;
        order.calculatedDiscountTotal = (0, fixPrecision_1.roundToFiveDecimal)(calculatedDiscountTotal);
        // 訂單總計
        order.total = order.enableIntermediateRounding ? (0, round_1.roundByCurrency)(order, total) : (0, fixPrecision_1.roundToFiveDecimal)(total);
        // 顯示用的訂單總計
        order.roundedTotal = (0, fixPrecision_1.roundToFiveDecimal)(Math.max(0, (0, round_1.default)(order.total, order.rounding.type, order.rounding.digits)));
        // 倒推稅前總計
        order.totalBeforeTax = (0, round_1.roundByCurrency)(order, (0, precisionMath_1.subtract)(order.total, order.taxTotal));
        // 顯示用的訂單狀態
        order.displayStatusKey = (0, getDisplayStatusKey_1.default)(order);
        if (order.enableIntermediateRounding) {
            order.taxableTotal = (0, round_1.default)(order.taxableTotal, order.rounding.type, order.rounding.digits);
            order.nonTaxableTotal = (0, round_1.default)(order.nonTaxableTotal, order.rounding.type, order.rounding.digits);
            order.shippingFee = (0, round_1.default)(order.shippingFee, order.rounding.type, order.rounding.digits);
            order.originalShippingFee = (0, round_1.default)(order.originalShippingFee, order.rounding.type, order.rounding.digits);
            order.discountShippingFee = (0, round_1.default)(order.discountShippingFee, order.rounding.type, order.rounding.digits);
            order.calculatedDiscountTotal = (0, round_1.default)(order.calculatedDiscountTotal, order.rounding.type, order.rounding.digits);
            order.surchargeTotal = (0, round_1.default)(order.surchargeTotal, order.rounding.type, order.rounding.digits);
        }
        // total 被 round 後的差價
        order.roundedAmount = (0, round_1.roundByCurrency)(order, (0, precisionMath_1.subtract)(order.roundedTotal, order.total));
        // FIXME: 目前只支援單一稅率的計算, 多個稅率會有問題, 但實例上也不會有多個>0%的稅率, 所以先這樣寫, 以後再fix
        // Restore all original tax settings
        order.taxes = originalTaxes;
        return order;
    });
}
exports.default = calculateLocalOrder;
//# sourceMappingURL=calculateLocalOrder.js.map